__turbopack_context__.v({
  "IsCentered": "PeopleSection-module-scss-module__3Y16RW__IsCentered",
  "People": "PeopleSection-module-scss-module__3Y16RW__People",
  "PeopleSection": "PeopleSection-module-scss-module__3Y16RW__PeopleSection",
});
